import React, { useContext, useEffect, useRef } from "react"
import tw from "twin.macro"
import { DisclaimersContext } from "../../../contexts/Disclaimers"
import { Modal } from "../../atoms/Modal"
import { DisclaimersModalProps } from "./DisclaimersModal.d"
import { toggleDisclaimersModal } from "../../../contexts/Disclaimers/actions"
import { LanguageContext } from "../../../contexts/Language"
import { setIsDisclaimerModalOpen } from "../../../contexts/Disclaimers/context"

const DisclaimersModal = ({}: DisclaimersModalProps) => {
  const [{ disclaimers, open }, dispatch] = useContext(DisclaimersContext)
  const { language } = useContext(LanguageContext)
  const modalRef = useRef<HTMLDivElement>(null)

  // Close modal on outside click
  useEffect(() => {
    // Update global modal open state
    setIsDisclaimerModalOpen(open)

    if (!open) return

    const handleClickOutside = (e: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        e.stopPropagation() // prevent navmenu from closing
        dispatch(toggleDisclaimersModal()) // close modal
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [open, dispatch])

return (
    <>
      <Modal
        open={open}
        onClose={() => dispatch(toggleDisclaimersModal())}
        css={[
          tw`w-full max-w-lg lg:max-w-[60rem] max-h-[calc(100vh - 60px)] overflow-y-scroll`,
        ]}
      >
        <div
          data-disclaimer-modal="true"
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            e.nativeEvent?.stopImmediatePropagation?.()
          }}
          onMouseDown={e => {
            e.stopPropagation()
            e.preventDefault()
            e.nativeEvent?.stopImmediatePropagation?.()
          }}
          ref={modalRef}
        >
          <div css={[tw`px-6 pt-10 pb-4 w-full`]}>
            <ol css={[tw`p-0 py-4`]}>
              {disclaimers.map(
                (
                  { code, active, disclaimer, disclaimer_en, disclaimer_es },
                  i,
                ) => {
                  let disclaimerText
                  if (language === "es") {
                    disclaimerText = disclaimer ? disclaimer : disclaimer_es
                  } else {
                    disclaimerText = disclaimer ? disclaimer : disclaimer_en
                  }

                  if (!disclaimerText) return null
                  return (
                    <li
                      css={[
                        tw`py-1 px-2 rounded flex`,
                        active && tw`bg-gray-200`,
                      ]}
                      data-disclaimer-code={code}
                      key={`disclaimer-${code}-${i}`}
                    >
                      <span css={[tw`mr-2`]}>{i + 1}.</span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: disclaimerText,
                        }}
                      />
                    </li>
                  )
                },
              )}
            </ol>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default DisclaimersModal
